import { render, staticRenderFns } from "./LearnMoreAboutBGP.vue?vue&type=template&id=39fad9fb&scoped=true&"
import script from "./LearnMoreAboutBGP.vue?vue&type=script&lang=js&"
export * from "./LearnMoreAboutBGP.vue?vue&type=script&lang=js&"
import style0 from "./LearnMoreAboutBGP.vue?vue&type=style&index=0&id=39fad9fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fad9fb",
  null
  
)

export default component.exports